import { render, staticRenderFns } from "./PlatformInfo.vue?vue&type=template&id=33f699aa&scoped=true&"
import script from "./PlatformInfo.vue?vue&type=script&lang=js&"
export * from "./PlatformInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlatformInfo.vue?vue&type=style&index=0&id=33f699aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f699aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f699aa')) {
      api.createRecord('33f699aa', component.options)
    } else {
      api.reload('33f699aa', component.options)
    }
    module.hot.accept("./PlatformInfo.vue?vue&type=template&id=33f699aa&scoped=true&", function () {
      api.rerender('33f699aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/intake/children/detail/components/PlatformInfo.vue"
export default component.exports